'use strict';

import React, { Component } from 'react';
import axios from 'axios';
import { isMobile, isTablet } from "react-device-detect";

import MapMenuContainer from './MapMenuContainer';
import MapContainer from './MapContainer';
import MapFooterContainer from './MapFooterContainer';

import getDataFromFB from '../helpers/getDataFromFB';
import sortEvents from '../helpers/sortEvents';
import formatDate from '../helpers/formatDate';
import getDistance from '../helpers/getDistance';
import getMarkers from '../helpers/getMarkers';

import globalConfig from '../settings/config';

class AppContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mapCenter: globalConfig.map.default.center,
      menuStatus: false,
      isMapLoaded: false,
      loadMapFailed: false,
      haveResults: true,
      reloadMap: false,
      loadMapWithMarkers: false,
      selectedCollection: globalConfig.collections.default.name,
      selectedThemeColor: globalConfig.collections.default.color,
      selectedSortOption: 'metalocation',
      collLastUpdated: '',
      polygons: [],
      markers: [],
      events: [],
      tabInfoContent: '',
      activeMenuTab: 'tabMap',
      mapApiRef: '',
      mapRef: '',
      currentZoom: globalConfig.map.default.zoom,
      hideFilters: false,
    };

    this.handleMenuToggleClick = this.handleMenuToggleClick.bind(this);
    this.handleMapDataLoading = this.handleMapDataLoading.bind(this);
    this.onMapDataLoaded = this.onMapDataLoaded.bind(this);
    this.handleMapCompelted = this.handleMapCompelted.bind(this);
    this.handleReloadMapRequest = this.handleReloadMapRequest.bind(this);
    this.locateUser = this.locateUser.bind(this);
    this.setGlobalMapApi = this.setGlobalMapApi.bind(this);
    this.setCurrentZoomLevel = this.setCurrentZoomLevel.bind(this);
    this.handleEventsSort = this.handleEventsSort.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleMenuTabClick = this.handleMenuTabClick.bind(this);
    this.handleCollectionSelected = this.handleCollectionSelected.bind(this);
    this.getThemeColor = this.getThemeColor.bind(this);
    this.handleReloadEventListRequest = this.handleReloadEventListRequest.bind(this);
  }

  locateUser(setZoom) {
    this.handleMapDataLoading();
    const locateTimeout = setTimeout(() => {
      this.handleLocateUserFailed();
    }, 10000);
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        var currentPosition = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        if (currentPosition.lat && currentPosition.lng) {
          this.setState({
            mapCenter: { lat: currentPosition.lat, lng: currentPosition.lng },
          });

          if(setZoom) {
            console.log('------ zoom in here ------');
            this.state.mapRef && this.state.mapRef.setZoom(14);
            this.handleReloadEventListRequest();
          } else {
            this.handleReloadMapRequest();
          }

          clearTimeout(locateTimeout);
        }
      });
    } else {
      console.log('----- failed to locate user -----');
      this.handleLocateUserFailed();
    }
  }

  handleMapCompelted() {
    this.setState({
      isMapLoaded: true,
    });

    this.loadInfoTabContent();
  }

  handleMapDataLoading() {
    this.setState({
      isMapLoaded: false,
    });
  }

  handleReloadMapRequest() {
    const locateTimeout = setTimeout(() => {
      this.handleLoadMapDataFailed();
    }, 10000);

    const centerObj = this.state.mapRef.getCenter();
    const center = { lat: centerObj.lat(), lng: centerObj.lng() };

    let viewStitchLevel = 10;
    if (isMobile) {
      viewStitchLevel = 11;
    }

    //Please don't remove the following line. Check Dev Dairy for more info
    //const loadMapWithMarkers = this.state.currentZoom >= viewStitchLevel ? false : true;

    const loadMapWithMarkers = false;

    let maxdist = 1500;
    if (!loadMapWithMarkers) {
      maxdist = getDistance(this.state.mapRef);
    }

    getDataFromFB(
      this.state.selectedCollection,
      center.lat,
      center.lng,
      maxdist,
      false,
      resultsObj => {
        if (Object.keys(resultsObj).length == 2) {
          const keys = Object.keys(resultsObj);
          const newState = {
            markers: [],
            polygons: [],
            events: [],
            collLastUpdated: '',
          };
          for (let key of keys) {
            if (key == 'markers') {
              newState.markers = resultsObj[key];
              console.info(newState.markers);
            } else if (key == 'polygons') {
              newState.polygons = resultsObj[key];
              newState.events = sortEvents(
                resultsObj[key],
                this.state.selectedSortOption,
              );

              let markers = getMarkers(resultsObj[key]);

              if (markers.length > 0) {
                newState.markers = markers;
              }

              setTimeout(() => {
                this.handleMapCompelted();
              }, resultsObj[key]);
            } else if (key == 'collLastUpdated') {
              newState.collLastUpdated = formatDate(resultsObj[key]);
            }
          }

          this.setState(newState);
          this.handleMapCompelted();
        } else {
          const newState = {
            polygons: [],
            events: [],
          };
          this.setState(newState);
          this.handleMapCompelted();
        }

        clearTimeout(locateTimeout);
      },
    );
  }

  handleReloadEventListRequest() {
    const locateTimeout = setTimeout(() => {
      this.handleLoadMapDataFailed();
    }, 10000);

    const centerObj = this.state.mapRef.getCenter();
    const center = { lat: centerObj.lat(), lng: centerObj.lng() };

    const loadMapWithMarkers = false;

    let maxdist = 1500;
    maxdist = getDistance(this.state.mapRef);

    getDataFromFB(
      this.state.selectedCollection,
      center.lat,
      center.lng,
      maxdist,
      loadMapWithMarkers,
      resultsObj => {
        if (Object.keys(resultsObj).length == 2) {
          const keys = Object.keys(resultsObj);
          const newState = {
            events: [],
            haveResults: true
          };
          for (let key of keys) {
            if (key == 'polygons') {
              newState.events = sortEvents(
                resultsObj[key],
                this.state.selectedSortOption,
              );

              setTimeout(() => {
                this.handleMapCompelted();
              }, resultsObj[key]);
            }
          }

          this.setState(newState);
          this.handleMapCompelted();
        } else {
          const newState = {
            events: [],
            haveResults: false
          };
          this.setState(newState);
          this.handleMapCompelted();
        }

        clearTimeout(locateTimeout);
      },
    );
  }

  handleMenuToggleClick() {
    const newState = {
      menuStatus: !this.state.menuStatus,
    };

    if (isMobile) {

      if (isTablet) {
        if (window.orientation == 90) {
          if (this.state.activeMenuTab == 'tabMap') {
            newState.activeMenuTab = 'tabList';
          }
        } else {
          newState.activeMenuTab = 'tabMap';
        }
      } else {
        newState.activeMenuTab = 'tabMap';
      }

    } else {
      if (this.state.activeMenuTab == 'tabMap') {
        newState.activeMenuTab = 'tabList';
      }
    }
    this.setState(newState);
  }

  handleMenuTabClick(tabIndex) {
    this.setState({ activeMenuTab: tabIndex });
  }

  onMapDataLoaded() {
    this.setState({
      isMapLoaded: true,
    });
  }

  loadInfoTabContent() {
    axios
      .get(globalConfig.endpoints.infoPanel.url)
      .then(response => {
        if (response.data.length > 0) {
          this.setState({
            tabInfoContent: response.data,
          });
        }
      })
      .catch(error => {
        this.setState({
          tabInfoContent: 'Unable to retrieve infomation',
        });
      });
  }

  handleLoadMapDataFailed() {
    this.setState({
      loadMapFailed: true,
    });
  }

  handleLocateUserFailed() {
    alert('Location services are disabled!');
    this.handleReloadMapRequest();
  }

  setGlobalMapApi(mapApi, map) {
    this.setState({
      mapApiRef: mapApi,
      mapRef: map,
    });
    this.locateUser(false);
  }

  setCurrentZoomLevel(zoomLevel) {
    this.setState({
      currentZoom: zoomLevel
    });
  }

  handleEventsSort(sortOption) {
    if (sortOption != this.state.selectedSortOption) {
      const sortedEvents = sortEvents(this.state.events, sortOption);
      const newState = {
        selectedSortOption: sortOption,
        events: sortedEvents,
      };
      this.setState(newState);
    }
  }

  handleSearch(mapCenter) {
    this.setState({
      mapCenter: mapCenter,
    });

    this.state.mapRef && this.state.mapRef.setZoom(14);
    this.handleReloadEventListRequest();
  }

  handleCollectionSelected(collection) {
    if (collection != this.state.selectedCollection) {
      this.setState({
        selectedCollection: collection,
        selectedThemeColor: this.getThemeColor(collection)
      });

      //need to reload map here after handleReloadMapRequest
    }
  }

  //utilities
  getThemeColor(collection) {

    for (let key in globalConfig.collections) {
      const collectionObj = globalConfig.collections[key];
      if (collectionObj.name === collection) {
        return collectionObj.color;
      }
    }

    return globalConfig.collections.default.color;
  }

  render() {
    return (
      <div>
        <MapMenuContainer
          menuStatus={this.state.menuStatus}
          markers={this.state.markers}
          polygons={this.state.polygons}
          events={this.state.events}
          tabInfoContent={this.state.tabInfoContent}
          mapApiRef={this.state.mapApiRef}
          mapRef={this.state.mapRef}
          activeMenuTab={this.state.activeMenuTab}
          collLastUpdated={this.state.collLastUpdated}
          selectedSortOption={this.state.selectedSortOption}
          selectedCollection={this.state.selectedCollection}
          handleEventsSort={this.handleEventsSort}
          handleSearch={this.handleSearch}
          handleMenuToggleClick={this.handleMenuToggleClick}
          handleMenuTabClick={this.handleMenuTabClick}
          handleMyLocationClick={this.locateUser}
          handleCollectionSelected={this.handleCollectionSelected}
        />
        <MapContainer
          menuStatus={this.state.menuStatus}
          mapCenter={this.state.mapCenter}
          markers={this.state.markers}
          polygons={this.state.polygons}
          selectedThemeColor={this.state.selectedThemeColor}
          currentZoom={this.state.currentZoom}
          mapApiRef={this.state.mapApiRef}
          isMapLoaded={this.state.isMapLoaded}
          loadMapFailed={this.state.loadMapFailed}
          haveResults={this.state.haveResults}
          handleMapCompelted={this.handleMapCompelted}
          handleMapDataLoading={this.handleMapDataLoading}
          handleReloadMapRequest={this.handleReloadMapRequest}
          setGlobalMapApi={this.setGlobalMapApi}
          setCurrentZoomLevel={this.setCurrentZoomLevel}
          handleReloadEventListRequest={this.handleReloadEventListRequest}
        />
        <MapFooterContainer
          selectedCollection={this.state.selectedCollection}
        />
      </div>
    );
  }
}

export default AppContainer;
